module.exports = __webpack_public_path__ + "static/img/image-2.d1163cd5.png";